module.exports = __webpack_public_path__ + "img/imac-bottom-border.5585273c.png";